import React, { useState, useEffect } from 'react';
import { LinearProgress, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import { useMediaQuery } from 'react-responsive';
import Chart from 'react-apexcharts';
import { Link } from 'react-router-dom';
import ArrowDownwardRoundedIcon from '@material-ui/icons/ArrowDownwardRounded';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import DraftsOutlinedIcon from '@material-ui/icons/DraftsOutlined';
import ArrowUpwardRounded from '@material-ui/icons/ArrowUpwardRounded';
import Fade from '@material-ui/core/Fade';
import { storeContext } from '../provider/Provider';
import InfoCard from '../info-card/InfoCard';
import { getGrowthPercentage } from '../../functions';
import { websiteAnalyticsActions } from '../../store/website-analytics-reducer';
import ContentPipeline from '../content/ContentPipeline';
import { contentActions } from '../../store/content-reducer';
import { leadsActions } from '../../store/leads-reducer';
import chartOptions from '../../customUI/ChartOptions';
import MobileTitle from '../../customUI/MobileTitle';

import { campaignUpdatesActions } from '../../store/campaign-updates-reducer';
import CONSTANTS from '../../utils/constants';

const { REACT_APP_FLASK_API_URL } = process.env;

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
  },
  toolbar: theme.mixins.toolbar,
  home__flex: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  lead__flex: {
    display: 'flex',
  },
  flex__item: {
    flexGrow: 1,
    margin: 15,
    width: '30%',
  },
  flex__item1: {
    margin: 15,
    width: '200px',
  },
  flex__item_50: {
    flexGrow: 1,
    margin: 15,
    width: '50%',
  },
  colorPrimary: {
    backgroundColor: '#E5E5E5',
  },
  barColorPrimary: {
    backgroundColor: '#00B5E2',
  },
  dashboard__heading: {
    margin: '10px 0 10px 10px',
    fontWeight: 700,
    fontSize: 25,
    color: '#58595B',
  },
  wrapper: {
    margin: 20,
    [theme.breakpoints.down('sm')]: {
      margin: '0 15px',
    },
  },
  card: {
    padding: 15,
    background: 'white',
    borderRadius: '16px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    [theme.breakpoints.down('sm')]: {
      padding: 5,
      marginBottom: 15,
    },
  },
  heading: {
    padding: '0 0 10px 16px',
    fontSize: 30,
    fontWeight: 700,
    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
      padding: '0 0 5px 5px',
    },
  },
  leadsCardInner: {
    color: '#58595B',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  leadsCount: {
    fontSize: '4rem',
    fontWeight: 700,
    lineHeight: 1,
    [theme.breakpoints.down('sm')]: {
      fontSize: 40,
    },
  },
  leadsCardTop: {
    marginBottom: 60,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0,
      marginRight: 20,
    },
  },
  leadsEmphasis: {
    fontSize: '1.125rem',
    fontWeight: 500,
  },
  leadsEmphasisPercentage: {
    fontWeight: 500,
    fontSize: 26,
  },
  leadsCard: {
    padding: '43px 30px',
    background: 'white',
    borderRadius: '16px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    '&:hover': {
      background: '#f3f3f3',
    },
    [theme.breakpoints.down('sm')]: {
      padding: 20,
      marginBottom: 15,
    },
  },
  leadsRound: {
    borderRadius: 33,
    width: 33,
    height: 33,
    margin: '15px auto',
    display: 'flex',
    justifyContent: 'center',
    '& svg': {
      alignSelf: 'center',
    },
    [theme.breakpoints.down('sm')]: {
      width: 30,
      height: 30,
      margin: '5px auto',
    },
  },
  mobileInfoCard: {
    margin: 15,
  },
}));

const Home = () => {
  const isPhone = useMediaQuery({ query: '(max-width: 768px)' });
  const [cookies] = useCookies(['auth']);
  const { state, dispatch } = React.useContext(storeContext);
  const classes = useStyles();
  const [news, setNews] = useState([]);

 useEffect(() => {
    if (state.campaignUpdates.messages === null)
      return;

    setNews(state.campaignUpdates.messages);
  }, [state.campaignUpdates]);

  const handleDiscardNotification = (messageId) => {
    axios.post(
      `${REACT_APP_FLASK_API_URL}/v1/loom/mark-seen/${state.websiteSwitch.currentWebsite}`,
      {
        message_ids: [ messageId ],
      }
    ).then(() => {
      const currNews = news?.filter((item) => item.message_id !== messageId);
      setNews(currNews);
      dispatch({
        type: campaignUpdatesActions.CAMPAIGN_UPDATES_SET_ALL,
        payload: {
          newMessagesCount: currNews.length,
          messages: currNews
        },
      });
    });
  };
  
  /* const data = [];
  let initialDate = '0000-01-01';

   useEffect(() => {
    axios.get(`${REACT_APP_FLASK_API_URL}/keywords/${state.websiteSwitch.currentWebsite}`)?.then(res => {

      const top5KeyWords = res.data.data.reduce((result, obj) => {
        const key = obj.kw;
        const newObj = { ...result };
        if (!newObj[key]) {
          newObj[key] = [];
        }
        newObj[key].push(obj);
        return newObj;
      }, {});


      Object.keys(top5KeyWords).forEach(key => {
        if (Array.isArray(top5KeyWords[key])) {
          const value = top5KeyWords[key].map(obj => obj.google_rank);
          const date = top5KeyWords[key].map(obj => obj.date);
          initialDate = new Date(date[0]) > new Date(initialDate)? date[0]: initialDate;
          data.push({
            name: key,
            data: value,
            date
          });
        }
      });

      const updatedResponse = data.map(obj => {
        const trimmedData = obj.data.filter((_, i) => new Date(obj.date[i]) > new Date(initialDate) || initialDate === obj.date[i]);
        const trimmedDate = obj.date.filter((d) => new Date(d) > new Date(initialDate) || initialDate === d);
        const initialDay = moment(initialDate).format('dddd');
        const newData = trimmedData.filter((_, index) => moment(trimmedDate[index]).format('dddd') === initialDay);
        const newDate = trimmedDate.filter((rd) => moment(rd).format('dddd') === initialDay);

        return {
          ...obj,
          data: newData,
          date: newDate.map(dateString => {
            const [year, month, day] = dateString.split('-');
            const formattedDate = `${month}-${day}-${year.slice(-2)}`;
            return formattedDate;
          }),
        };
      });

      if (updatedResponse.length > 0) {
        setDateValue(updatedResponse[0].date)
        setKeyValues(updatedResponse)
      }
    })
  }, []) */

  useEffect(() => {
    if (cookies.id_token) {
      dispatch({
        type: websiteAnalyticsActions.WEBSITE_ANALYTICS_SET_IS_FETCHING,
        payload: { isFetching: true },
      });
      axios
        .get(
          `${REACT_APP_FLASK_API_URL}/v1/analytics/monthly/${state.websiteSwitch.currentWebsite}`
        )
        ?.then((res) => {
          if (!res.data.error) {
            axios
              .get(
                `${REACT_APP_FLASK_API_URL}/v1/budget-history/${state.websiteSwitch.currentWebsite}`
              )
              ?.then((res2) => {
                dispatch({
                  type: websiteAnalyticsActions.WEBSITE_ANALYTICS_SET_ALL,
                  payload: {
                    history: res.data.data.length > 0? res.data.data.filter((hst) => new Date(hst.end_date) > new Date(CONSTANTS.JulyDate)): res.data.data,
                    budgetHistory: res2.data.data,
                  },
                });
                dispatch({
                  type: websiteAnalyticsActions.WEBSITE_ANALYTICS_SET_IS_FETCHING,
                  payload: { isFetching: false },
                });
              });
          }
        });
      axios
        .get(
          `${REACT_APP_FLASK_API_URL}/v1/semrush-averages/${state.websiteSwitch.currentWebsite}/12`
        )
        ?.then((res) => {
          dispatch({
            type: websiteAnalyticsActions.WEBSITE_ANALYTICS_SET_ALL,
            payload: {
              semrushAverages: res.data.data,
            },
          });
        });
      axios
        .get(
          `${REACT_APP_FLASK_API_URL}/dash2-proxy/client-content/websites/${state.websiteSwitch.currentWebsite}/analytics/totals/`
        )
        ?.then((res) => {
          if (res.status === 200) {
            dispatch({
              type: contentActions.CONTENT_SET_ALL,
              payload: {
                contentPipeline: res.data['by-status'],
              },
            });
          }
        });
      axios
        .get(
          `${REACT_APP_FLASK_API_URL}/v1/get-call-metrics-totals/${state.websiteSwitch.currentWebsite}`
        )
        ?.then((res) => {
          dispatch({
            type: leadsActions.LEADS_SET_ALL,
            payload: {
              callsByMonth: res.data.callsByMonth ? JSON.parse(res.data.callsByMonth) : {},
              currentPeriodCallsCount: res.data.callsCurrentMonth,
              prevPeriodCallsCount: res.data.callsLastMonth,
            },
          });
        });
      axios
        .get(`${REACT_APP_FLASK_API_URL}/v1/leads/${state.websiteSwitch.currentWebsite}/count`)
        ?.then((res) => {
          dispatch({
            type: leadsActions.LEADS_SET_ALL,
            payload: {
              isFetching: false,
              allLeadsCount: res.data.data.allLeadsCount,
              leadsByMonth: res.data.data.leadsByMonth
                ? JSON.parse(res.data.data.leadsByMonth)
                : {},
              currentPeriodLeadsCount: res.data.data.leadsCurrentMonth,
              prevPeriodLeadsCount: res.data.data.leadsLastMonth,
            },
          });
        });
    }
  }, []);
  const barChartOptions = {
    ...chartOptions,
    labels: state.websiteAnalytics.gaROILabels,

    tooltip: {
      x: { show: false },
      y: {
        formatter: (v) => `CPL: $${v}`,
        title: {
          formatter: () => '',
        },
      },
    },
  };
  barChartOptions.colors = ['#00B5E2'];
  barChartOptions.plotOptions.bar.columnWidth = '70%';
  const lineOptions = {
    ...chartOptions,
    labels: state.websiteAnalytics.gaLeadsLabels,
    markers: {
      size: 5
    },
    yaxis: [
      {
        seriesName: 'Organic Sessions',
        title: {
          text: 'Organic Sessions',
        },
      },
      {
        seriesName: 'Organic Leads',
        opposite: true,
        title: {
          text: 'Organic Leads',
        },
      },
      // {
      //   seriesName: 'Leads Count',
      //   title: {
      //     text: "Leads Count",
      //   }
      // },
    ],
    noData: {
      text: 'Leads Information Not Provided',
      align: 'center',
      verticalAlign: 'middle',
      offsetY: -12,
      style: {
        fontSize: isPhone ? '13px' : '16px',
        color: '#a9acad'
      }
    }
  };
  lineOptions.stroke = {
    curve: 'smooth',
  };
  lineOptions.colors = ['#00B5E2', '#8bc349'];
  const costPerLeadOptions = {
    ...chartOptions,
    stroke: {
      curve: 'smooth',
      width: [0, 0, 3],
    },
    colors: [
      '#4a74b6',
      '#8bc349',
      // '#f6a340'
    ],
    grid: {
      borderColor: '#e7e7e7',
      row: {
        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        opacity: 0.5
      },
    },
    labels: state.websiteAnalytics.gaLeadsLabels,
    yaxis: [
      {
        seriesName: 'Budget',
        title: {
          text: 'Budget',
        },
        labels: {
          formatter: (value) => {
            const formatter = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              maximumFractionDigits: 0,
            });
            return formatter.format(value);
          },
        },
      },
      {
        seriesName: 'CPL',
        opposite: true,
        title: {
          text: 'CPL',
        },
        labels: {
          formatter: (value) => {
            const formatter = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              maximumFractionDigits: 0,
            });
            return formatter.format(value);
          },
        },
      },
      // {
      //   seriesName: 'Leads Count',
      //   title: {
      //     text: "Leads Count",
      //   }
      // },
    ],
    tooltip: {
      y: {
        formatter: (value) => {
          const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0,
          });
          return formatter.format(value);
        },
      },
      fixed: {
        enabled: true,
        position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
        offsetY: 0,
        offsetX: 0,
      },
    },
    noData: {
      text: 'Budget Information Not Provided',
      align: 'center',
      verticalAlign: 'middle',
      offsetY: -12,
      style: {
        fontSize: isPhone ? '13px' : '16px',
        color: '#a9acad'
      }
    }
  };
  costPerLeadOptions.plotOptions.bar.columnWidth = '70%';
  if (state.websiteAnalytics.isFetching) {
    return (
      <LinearProgress
        style={{ width: '100%' }}
        classes={{
          colorPrimary: classes.colorPrimary,
          barColorPrimary: classes.barColorPrimary,
        }}
      />
    );
  }
  const trafficSeries = {
    name: 'Organic Sessions',
    data: state.websiteAnalytics.sessionsValues[0].data.slice(-6)
  }

  const leadSeries = {
    name: 'Organic Leads',
    data: state.websiteAnalytics.gaLeadsValues[0].data
  }

  const seriesArray = [
    trafficSeries,
    leadSeries,
  ];

  // Calculate the maximum value from all the data arrays
  /* const maxValue = Math.max(...keyValues.flatMap((item) => item.data));

  const keyWordLineOptions = {
    ...chartOptions,
    labels: dateValue,
    markers: {
      size: 5
    },
    yaxis: {
      seriesName: 'Google Rank',
      min: 1,
      max: maxValue, // Set the maximum value based on the calculated maximum
      title: {
        text: 'Google Rank',
      },
    },
    xaxis: {
      categories: [...dateValue],
    },
    noData: {
      text: 'Keywords Information Not Provided',
      align: 'center',
      verticalAlign: 'middle',
      offsetY: -12,
      style: {
        fontSize: isPhone ? '13px' : '16px',
        color: '#a9acad'
      }
    }
  } */

  /* keyWordLineOptions.stroke = {
    curve: 'smooth',
  };
  keyWordLineOptions.colors = ['#00B5E2', '#8bc349', '#12cf4b', '#f0Ba05', '#29139e'];
 */

  /* const keyWordArray = [
    ...keyValues,
  ] */

  if (isPhone) {
    return (
      <>
        <MobileTitle title="Overview" />
        <div className={classes.wrapper}>
          {
            state.campaignUpdates?.newMessagesCount && news.length > 0 ?
              news.length > 0 && news.map((item) => <> 
              <Fade in={!item.is_seen_by_client}>
                <div className={classes.card} style={{ border: '1px solid #00B5E2', marginBottom: '10px'  }}>
                  <div className={classes.heading} style={{ display: 'flex', color: '#58595B', justifyContent: 'space-between', padding: '0' }}>
                    <div style={{ display: 'flex', alignItems: 'center', flex: '1', maxWidth: '100%', overflow: 'hidden' }}>
                      <div style={{ color: '#00B5E2', marginLeft: '5px', marginRight: '10px' }}><NotificationsNoneIcon /></div>
                      <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '10px', width: '50%',  }}>
                        <div style={{ fontSize: '20px', fontWeight: 'bolder', color: 'black' }}>{item.title}</div>
                        <span style={{
                          fontSize: '15px',
                          color: 'grey',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                        }}>{item.message}</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', color: 'grey', marginLeft: 'auto' }}>
                        <Link to="/campaign-updates" style={{ marginTop: '2px', marginRight: '10px', color: 'grey' }}>
                          <div style={{ marginRight: '5px', }}><DraftsOutlinedIcon /></div>
                        </Link>
                        <Box style={{ cursor: 'pointer', color: 'grey' }} onClick={() => handleDiscardNotification(item.message_id)}><DeleteOutlinedIcon /></Box>
                      </div>
                    </div>
                  </div>
                </div>
              </Fade>
              </>)
              : <></>
          }
          <Link to="/leads" style={{ textDecoration: 'none', display: 'none' }}>
            {state.leads.currentPeriodCallsCount + state.leads.currentPeriodLeadsCount >
              state.leads.prevPeriodCallsCount + state.leads.prevPeriodLeadsCount ? (
              <div className={classes.leadsCard}>
                <div className={classes.leadsCardInner}>
                  <div className={classes.leadsCardTop}>
                    <span className={classes.leadsCount} style={{ color: '#5AA600' }}>
                      {state.leads.currentPeriodCallsCount + state.leads.currentPeriodLeadsCount}
                    </span>
                    <br />
                    <span className={classes.leadsEmphasis}>New Leads</span>
                    <br />
                    <span className={classes.leadsEmphasis}>past 4 weeks</span>
                  </div>
                  <div>
                    <span className={classes.leadsRound} style={{ background: '#5AA600' }}>
                      <ArrowUpwardRounded style={{ color: 'white' }} />
                    </span>
                    <span className={classes.leadsEmphasisPercentage}>
                      {getGrowthPercentage(
                        state.leads.prevPeriodCallsCount + state.leads.prevPeriodLeadsCount,
                        state.leads.currentPeriodCallsCount + state.leads.currentPeriodLeadsCount,
                        0
                      ).toString()}
                      %
                    </span>
                    <br />
                    from previous period
                  </div>
                </div>
              </div>
            ) : (
              <div className={classes.leadsCard}>
                <div className={classes.leadsCardInner}>
                  <div className={classes.leadsCardTop}>
                    <span className={classes.leadsCount} style={{ color: '#d80000' }}>
                      {state.leads.currentPeriodCallsCount + state.leads.currentPeriodLeadsCount}
                    </span>
                    <br />
                    <span className={classes.leadsEmphasis}>New Leads</span>
                    <br />
                    <span className={classes.leadsEmphasis}>past 4 weeks</span>
                  </div>
                  <div>
                    <span className={classes.leadsRound} style={{ background: '#d80000' }}>
                      <ArrowDownwardRoundedIcon style={{ color: 'white' }} />
                    </span>
                    <span className={classes.leadsEmphasisPercentage}>
                      {getGrowthPercentage(
                        state.leads.prevPeriodCallsCount + state.leads.prevPeriodLeadsCount,
                        state.leads.currentPeriodCallsCount + state.leads.currentPeriodLeadsCount,
                        0
                      ).toString()}
                      %
                    </span>
                    <br />
                    from previous period
                  </div>
                </div>
              </div>
            )}
          </Link>
          <div className={classes.card}>
            <div className={classes.heading} style={{ color: '#58595B' }}>
              Leads vs Traffic
            </div>
            <Chart
              options={lineOptions}
              series={state.websiteAnalytics.gaLeadsValues}
              type="line"
              height="250"
            />
          </div>
          <div className={classes.card}>
            <div className={classes.heading} style={{ color: '#58595B' }}>
              Cost Per Lead
            </div>
            <Chart
              options={costPerLeadOptions}
              series={state.websiteAnalytics.gaThreeLinesValues}
              type="line"
              height="250"
            />
          </div>
          {/* <div className={classes.card} >
            <div className={classes.heading} style={{ color: '#58595B', display: state?.auth?.user?.email.includes("hennessey") ? "block" :  "none" }}>
              Keywords Performance
            </div>
            <>
              <Chart
                options={keyWordLineOptions}
                series={keyWordArray}
                type="line"
                height="250"
              />
            </>
          </div> */}
          <div className={classes.card}>
            <div className={classes.heading} style={{ color: '#58595B' }}>
              Organic Insights
            </div>
            {state.websiteAnalytics.sessions.toString() === '0' ? (
              <InfoCard
                name="Organic Sessions"
                value=""
                explanation="Make sure Hennessey Digital has access to your Google Analytics account to connect this feature by adding this email: hd-platform-analytics-api@kinetic-harbor-307817.iam.gserviceaccount.com"
                tooltip="This represents traffic that arrives at your site through a search engine result. A 'session' is defined as a group of hits (a single event like a page view or click). Think of an 'organic session' as a visit to your site that came through a Google search."
              />
            ) : (
              <InfoCard
                percentage={
                  state.websiteAnalytics.sessions
                    ? getGrowthPercentage(
                      state.websiteAnalytics.sessionsPrev,
                      state.websiteAnalytics.sessions
                    ).toString()
                    : '0'
                }
                name="Organic Sessions"
                value={state.websiteAnalytics.sessions.toString()}
                isFetching={state.websiteAnalytics.isFetching}
                historyValues={state.websiteAnalytics.sessionsValues}
                labels={state.websiteAnalytics.sessionsLabels}
                chartColor="#bb1ddb"
                chartType="bar"
                tooltip="This represents traffic that arrives at your site through a search engine result. A 'session' is defined as a group of hits (a single event like a page view or click). Think of an 'organic session' as a visit to your site that came through a Google search."
              />
            )}
            {state.websiteAnalytics.queries.toString() === '0' ? (
              <InfoCard
                name="Queries"
                value=""
                explanation="Make sure Hennessey Digital has access to your Search Console Property account to connect this feature by adding this email: hd-platform-analytics-api@kinetic-harbor-307817.iam.gserviceaccount.com"
                tooltip="Queries represent words or phrases that users type into search that made your website come up in organic search results."
              />
            ) : (
              <InfoCard
                percentage={
                  state.websiteAnalytics.queries
                    ? getGrowthPercentage(
                      state.websiteAnalytics.queriesPrev,
                      state.websiteAnalytics.queries
                    ).toString()
                    : '0'
                }
                name="Queries"
                value={state.websiteAnalytics.queries.toString()}
                isFetching={state.websiteAnalytics.isFetching}
                historyValues={state.websiteAnalytics.queriesValues}
                labels={state.websiteAnalytics.queriesLabels}
                chartColor="#F4931F"
                chartType="bar"
                tooltip="Queries represent words or phrases that users type into search that made your website come up in organic search results."
              />
            )}
            {state.websiteAnalytics.impressions.toString() === '0' ? (
              <InfoCard
                name="Impressions"
                value=""
                explanation="Make sure Hennessey Digital has access to your Search Console Property account to connect this feature by adding this email: hd-platform-analytics-api@kinetic-harbor-307817.iam.gserviceaccount.com"
                tooltip="This represents the number of times any page from your site appeared in search results viewed by a user, not including paid Google Ads search impressions."
              />
            ) : (
              <InfoCard
                percentage={
                  state.websiteAnalytics.impressions
                    ? getGrowthPercentage(
                      state.websiteAnalytics.impressionsPrev,
                      state.websiteAnalytics.impressions
                    ).toString()
                    : '0'
                }
                name="Impressions"
                value={state.websiteAnalytics.impressions.toString()}
                isFetching={state.websiteAnalytics.isFetching}
                historyValues={state.websiteAnalytics.impressionsValues}
                labels={state.websiteAnalytics.impressionsLabels}
                chartColor="#2A5CA9"
                chartType="bar"
                tooltip="This represents the number of times any page from your site appeared in search results viewed by a user, not including paid Google Ads search impressions."
              />
            )}
          </div>
          <div className={classes.card}>
            <div className={classes.heading} style={{ color: '#58595B' }}>
              Content Pipeline
            </div>
            <ContentPipeline />
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <div className={classes.wrapper}>
        {
          state.campaignUpdates?.newMessagesCount && news.length > 0 ?
            news.length > 0 && news.map((item) => <> 
            <Fade in={!item.is_seen_by_client}>
              <div className={classes.card} style={{ border: '1px solid #00B5E2', marginLeft: '15px', marginRight: '15px', marginBottom: '10px'  }}>
                <div className={classes.heading} style={{ display: 'flex', color: '#58595B', justifyContent: 'space-between', padding: '0' }}>
                  <div style={{ display: 'flex', alignItems: 'center', flex: '1', maxWidth: '100%', overflow: 'hidden' }}>
                    <div style={{ color: '#00B5E2', marginLeft: '5px', marginRight: '10px' }}><NotificationsNoneIcon /></div>
                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '10px', width: '70%',  }}>
                      <div style={{ fontSize: '20px', fontWeight: 'bolder', color: 'black' }}>{item.title}</div>
                      <span style={{
                        fontSize: '15px',
                        color: 'grey',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                      }}>{item.message}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', color: 'grey', marginLeft: 'auto' }}>
                      <div style={{ fontSize: '15px', marginRight: '30px' }}>{`${new Date(item.date_created).toLocaleString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                      })}`}</div>
                      <Link to="/campaign-updates" style={{ marginTop: '2px', marginRight: '10px', color: 'grey' }}>
                        <div style={{ marginRight: '5px', }}><DraftsOutlinedIcon /></div>
                      </Link>
                      <Box style={{ cursor: 'pointer', color: 'grey' }} onClick={() => handleDiscardNotification(item.message_id)}><DeleteOutlinedIcon /></Box>
                    </div>
                  </div>
                </div>
              </div>
            </Fade>
            </>)
            : <></>
        }
        <div className={classes.lead__flex}>
          <div className={classes.flex__item1} style={{ display: 'none' }}>
            <Link to="/leads" style={{ textDecoration: 'none' }}>
              {state.leads.currentPeriodCallsCount + state.leads.currentPeriodLeadsCount >
                state.leads.prevPeriodCallsCount + state.leads.prevPeriodLeadsCount ? (
                <div className={classes.leadsCard}>
                  <div className={classes.leadsCardInner}>
                    <div className={classes.leadsCardTop}>
                      <span className={classes.leadsCount} style={{ color: '#5AA600' }}>
                        {state.leads.currentPeriodCallsCount + state.leads.currentPeriodLeadsCount}
                      </span>
                      <br />
                      <span className={classes.leadsEmphasis}>New Leads</span>
                      <br />
                      <span className={classes.leadsEmphasis}>past 4 weeks</span>
                    </div>
                    <span className={classes.leadsRound} style={{ background: '#5AA600' }}>
                      <ArrowUpwardRounded style={{ color: 'white' }} />
                    </span>
                    <span className={classes.leadsEmphasisPercentage}>
                      {getGrowthPercentage(
                        state.leads.prevPeriodCallsCount + state.leads.prevPeriodLeadsCount,
                        state.leads.currentPeriodCallsCount + state.leads.currentPeriodLeadsCount,
                        0
                      ).toString()}
                      %
                    </span>
                    <br />
                    from previous period
                  </div>
                </div>
              ) : (
                <div className={classes.leadsCard}>
                  <div className={classes.leadsCardInner}>
                    <div className={classes.leadsCardTop}>
                      <span className={classes.leadsCount} style={{ color: '#d80000' }}>
                        {state.leads.currentPeriodCallsCount + state.leads.currentPeriodLeadsCount}
                      </span>
                      <br />
                      <span className={classes.leadsEmphasis}>New Leads</span>
                      <br />
                      <span className={classes.leadsEmphasis}>past 4 weeks</span>
                    </div>
                    <span className={classes.leadsRound} style={{ background: '#d80000' }}>
                      <ArrowDownwardRoundedIcon style={{ color: 'white' }} />
                    </span>
                    <span className={classes.leadsEmphasisPercentage}>
                      {getGrowthPercentage(
                        state.leads.prevPeriodCallsCount + state.leads.prevPeriodLeadsCount,
                        state.leads.currentPeriodCallsCount + state.leads.currentPeriodLeadsCount,
                        0
                      ).toString()}
                      %
                    </span>
                    <br />
                    from previous period
                  </div>
                </div>
              )}
            </Link>
          </div>
          <div className={classes.flex__item_50}>
            <div className={classes.card}>
              <div className={classes.heading} style={{ color: '#58595B' }}>
                Leads vs Traffic
              </div>
              <Chart
                options={lineOptions}
                series={seriesArray}
                type="line"
                height="250"
              />
            </div>
          </div>
          <div className={classes.flex__item_50}>
            <div className={classes.card}>
              <div className={classes.heading} style={{ color: '#58595B' }}>
                Cost Per Lead
              </div>
              <Chart
                options={costPerLeadOptions}
                series={state.websiteAnalytics.gaThreeLinesValues}
                type="line"
                height="250"
              />
            </div>
          </div>
        </div>
        {/* <div className={classes.card} style={{ margin: '15px', display: state?.auth?.user?.email.includes("hennessey") ? "block" :  "none" }}>
          <div className={classes.heading} style={{ color: '#58595B' }}>
            Keywords Performance
          </div>
          <>
            <Chart
              options={keyWordLineOptions}
              series={keyWordArray}
              type="line"
              height="250"
            />
          </>
        </div> */}
        <div className={classes.dashboard__heading} style={{ marginTop: '30px'}}>Organic Snapshot</div>  
        <div className={classes.home__flex}>
          <div className={classes.flex__item}>
            {state.websiteAnalytics.sessions.toString() === '0' ? (
              <InfoCard
                isFetching={false}
                percentage="100"
                name="Organic Sessions"
                value=""
                explanation="Make sure Hennessey Digital has access to your Google Analytics account to connect this feature by adding this email: hd-platform-analytics-api@kinetic-harbor-307817.iam.gserviceaccount.com"
                tooltip="This represents traffic that arrives at your site through a search engine result. A 'session' is defined as a group of hits (a single event like a page view or click). Think of an 'organic session' as a visit to your site that came through a Google search."
              />
            ) : (
              <InfoCard
                percentage={
                  state.websiteAnalytics.sessions
                    ? getGrowthPercentage(
                      state.websiteAnalytics.sessionsPrev,
                      state.websiteAnalytics.sessions
                    ).toString()
                    : '0'
                }
                name="Organic Sessions"
                value={state.websiteAnalytics.sessions.toString()}
                isFetching={state.websiteAnalytics.isFetching}
                historyValues={state.websiteAnalytics.sessionsValues}
                labels={state.websiteAnalytics.sessionsLabels}
                chartColor="#bb1ddb"
                chartType="bar"
                tooltip="This represents traffic that arrives at your site through a search engine result. A 'session' is defined as a group of hits (a single event like a page view or click). Think of an 'organic session' as a visit to your site that came through a Google search."
              />
            )}
          </div>
          <div className={classes.flex__item}>
            {state.websiteAnalytics.queries.toString() === '0' ? (
              <InfoCard
                name="Queries"
                value=""
                explanation="Make sure Hennessey Digital has access to your Search Console Property to connect this feature by adding this email: hd-platform-analytics-api@kinetic-harbor-307817.iam.gserviceaccount.com"
                tooltip="Queries represent words or phrases that users type into search that made your website come up in organic search results."
              />
            ) : (
              <InfoCard
                percentage={
                  state.websiteAnalytics.queries
                    ? getGrowthPercentage(
                      state.websiteAnalytics.queriesPrev,
                      state.websiteAnalytics.queries
                    ).toString()
                    : '0'
                }
                name="Queries"
                value={state.websiteAnalytics.queries.toString()}
                isFetching={state.websiteAnalytics.isFetching}
                historyValues={state.websiteAnalytics.queriesValues}
                labels={state.websiteAnalytics.queriesLabels}
                chartColor="#F4931F"
                chartType="bar"
                tooltip="Queries represent words or phrases that users type into search that made your website come up in organic search results."
              />
            )}
          </div>
          <div className={classes.flex__item}>
            {state.websiteAnalytics.impressions.toString() === '0' ? (
              <InfoCard
                name="Impressions"
                value=""
                explanation="Make sure Hennessey Digital has access to your Search Console Property to connect this feature by adding this email: hd-platform-analytics-api@kinetic-harbor-307817.iam.gserviceaccount.com"
                tooltip="This represents the number of times any page from your site appeared in search results viewed by a user, not including paid Google Ads search impressions."
              />
            ) : (
              <InfoCard
                percentage={
                  state.websiteAnalytics.impressions
                    ? getGrowthPercentage(
                      state.websiteAnalytics.impressionsPrev,
                      state.websiteAnalytics.impressions
                    ).toString()
                    : '0'
                }
                name="Impressions"
                value={state.websiteAnalytics.impressions.toString()}
                isFetching={state.websiteAnalytics.isFetching}
                historyValues={state.websiteAnalytics.impressionsValues}
                labels={state.websiteAnalytics.impressionsLabels}
                chartColor="#2A5CA9"
                chartType="bar"
                tooltip="This represents the number of times any page from your site appeared in search results viewed by a user, not including paid Google Ads search impressions."
              />
            )}
          </div>
        </div>
        <div className={classes.dashboard__heading}>Content Pipeline</div>
        <ContentPipeline />
      </div>
    </>
  );
};

export default Home;
